import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/config/rootReducer';

function useLanguageDirection() {
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { languageContext } = useSelector(
      (state: RootState) => state.general,
    );
    return languageContext.direction;
  } catch (err) {
    console.error('no General Reducer with languageContext', err);
    return 'ltr';
  }
}

export default useLanguageDirection;
